import type { ReactNode } from 'react';
import { Box, Grid, GridItem, HStack, Text, Tooltip, type GridProps } from '@chakra-ui/react';

export function languageListTemplateColumns(): string {
  return 'minmax(0, 1fr) auto';
}

// Must be a direct grid item of a container using languageListTemplateColumns (subgrid).
export function LanguageStatusRow({
  code,
  endonym,
  englishName,
  status,
  actions,
  leading,
  muted = false,
  nameTooltip,
  overlay,
  rowProps,
}: {
  code: string;
  endonym: string;
  englishName: string;
  status?: ReactNode;
  actions?: ReactNode;
  leading?: ReactNode;
  muted?: boolean;
  nameTooltip?: ReactNode;
  // Must be absolutely positioned, or it occupies the first subgrid track.
  overlay?: ReactNode;
  rowProps?: GridProps & { 'data-testid'?: string };
}) {
  const name = (
    /* Only the endonym is bidi-isolated so RTL scripts shape without flipping the row. */
    <Box minW={0}>
      <Text fontSize="sm" fontWeight="medium" noOfLines={1}>
        <Box as="bdi" lang={code} dir="auto">
          {endonym}
        </Box>
      </Text>
      <Text fontSize="xs" color="fg.muted" noOfLines={1}>
        {englishName}
      </Text>
    </Box>
  );

  return (
    <Grid
      gridColumn="1 / -1"
      templateColumns="subgrid"
      alignItems="center"
      opacity={muted ? 0.55 : 1}
      {...rowProps}
    >
      {overlay}
      <GridItem minW={0} display="flex" alignItems="center" gap={2}>
        {leading}
        {nameTooltip != null ? (
          <Tooltip label={nameTooltip} openDelay={200}>
            <Box minW={0} cursor="help">
              {name}
            </Box>
          </Tooltip>
        ) : (
          name
        )}
      </GridItem>

      <GridItem justifySelf="end">
        <HStack spacing={1.5}>
          {status}
          {actions}
        </HStack>
      </GridItem>
    </Grid>
  );
}
